import { Config } from "@config";
import { FeatureFlagProvider } from "@utils/FeatureFlagProvider";

export const FeatureFlagConfig = FeatureFlagProvider.getInstance(Config.getFeatureFlags());
